# frozen_string_literal: true

module Engine
  module Game
    module G1880
    end
  end
end
